import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { EMPTY_STRING } from '../../../../constants/common'
import { QA_NAME_CANCEL_BTN } from '../../../../constants/qa'
import { useMouseDownOutside } from '../../../../hooks'
import { preventDefault } from '../../../../utils/events'
import Button from '../../../Button'
import { TextareaInlineField } from '../../../Textarea'
import {
  QA_NAME_DELETE_CHECKLIST_ITEM_BUTTON,
  REQUEST_PROFILE_TAB_INTERNAL_TASKS_CHECKLIST_ITEM_MAX_LENGTH,
} from '../RequestProfileTabInternalTasks.constants'

import { getChecklistItemFormSubmitDisabled } from './RequestProfileTabInternalTasksChecklistItemForm.utils'

import * as styles from './RequestProfileTabInternalTasksChecklistItemForm.module.css'

import DeleteIcon from '../../../../icons/delete.svg'

function RequestProfileTabInternalTasksChecklistItemForm({
  initialValue = EMPTY_STRING,
  isLoading,
  placeholder,
  qaName,
  submitText,
  onCancel,
  onDelete,
  onSubmit,
}) {
  const { t } = useTranslation()

  const [text, setText] = useState(initialValue)

  const formRef = useRef(null)

  const textareaRef = useRef(null)

  useEffect(() => {
    textareaRef.current?.focus()
  }, [])

  // Discard the open form (cancel) when clicking anywhere outside it
  useMouseDownOutside(formRef, onCancel)

  function handleChange(value) {
    setText(value)
  }

  function handleSubmit() {
    onSubmit(text)
  }

  const isSubmitDisabled = getChecklistItemFormSubmitDisabled({
    initialValue,
    isLoading,
    text,
  })

  return (
    <div
      className={styles.RequestProfileTabInternalTasksChecklistItemForm}
      ref={formRef}
    >
      <div className={styles.fieldRow}>
        <div className={styles.field}>
          <TextareaInlineField
            autoResizeHeight
            borderless
            clearable
            withoutManualResize
            maxLength={
              REQUEST_PROFILE_TAB_INTERNAL_TASKS_CHECKLIST_ITEM_MAX_LENGTH
            }
            placeholder={placeholder}
            ref={textareaRef}
            value={text}
            onChange={handleChange}
          />
        </div>
        {onDelete ? (
          <Button.Icon
            isGrey
            Icon={DeleteIcon}
            className={styles.deleteButton}
            qaName={QA_NAME_DELETE_CHECKLIST_ITEM_BUTTON}
            tooltip={t('RequestProfile.InternalTasksDeleteTaskTooltipKey')}
            onClick={onDelete}
          />
        ) : null}
      </div>
      <div className={styles.actions}>
        <Button.Contained
          disabled={isSubmitDisabled}
          isLoading={isLoading}
          qaName={qaName}
          text={submitText}
          onClick={handleSubmit}
          onMouseDown={preventDefault}
        />
        <Button.Outlined
          qaName={QA_NAME_CANCEL_BTN}
          text={t('Modal.CancelBtnKey')}
          onClick={onCancel}
          onMouseDown={preventDefault}
        />
      </div>
    </div>
  )
}

export default RequestProfileTabInternalTasksChecklistItemForm
